<template>
    <!-- need to keep multiLineText and surrounding HTML tags on the same line because of white-space:pre-line -->
    <flex-element :element-type="elementType" class="f-break-words f-whitespace-pre-line" :tag="tag">{{ multiLineText }}</flex-element>
</template>

<script>
import baseAtom from '@/mixins/base-atom/base-atom-dumb';
import FlexElement from '@/flex-element/flex-element-dumb';

const MAX_CHARS_ATTR = 'max-characters';

export default {
    name: 'a-text-multi-line',
    components: { FlexElement },
    mixins: [baseAtom],

    props: {
        multiLineText: {
            type: String,
            default: '',
        },

        tag: {
            type: String,
            default: '',
        },
    },

    created() {
        const maxCharLimit = this.getElementData(MAX_CHARS_ATTR);

        return maxCharLimit
            ? `${ this.multiLineText.slice(0, maxCharLimit) }...`
            : this.multiLineText;
    },
};
</script>
